import React from "react";

const SchemaCtvs = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the difference between cardiac, thoracic, and vascular surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cardiac surgery deals with the heart, thoracic surgery focuses on the lungs and chest cavity, while vascular surgery involves the arteries and veins."
        }
      },
      {
        "@type": "Question",
        "name": "How long does recovery take after heart surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Recovery time varies depending on the procedure, but most patients can return to normal activities within 6–8 weeks with proper rehabilitation."
        }
      },
      {
        "@type": "Question",
        "name": "Is CTVS safe for older patients?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, with modern technology and skilled surgeons, CTVS procedures are safe even for elderly patients when proper pre-surgical assessment is done."
        }
      },
      {
        "@type": "Question",
        "name": "What symptoms indicate the need for cardiac surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Severe chest pain, shortness of breath, valve dysfunction, or heart failure symptoms may indicate the need for surgical evaluation."
        }
      },
      {
        "@type": "Question",
        "name": "What types of heart surgeries are performed at HDNA Aarogyam Hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We offer CABG (heart bypass), valve repair or replacement, aortic aneurysm surgery, and congenital heart defect correction using advanced techniques."
        }
      },
      {
        "@type": "Question",
        "name": "Are minimally invasive or robotic heart surgeries available?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. HDNA Aarogyam Hospital provides minimally invasive and advanced surgical options that reduce pain, scarring, hospital stay, and recovery time."
        }
      },
      {
        "@type": "Question",
        "name": "What conditions are treated under vascular surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Vascular surgery treats blocked arteries, aneurysms, carotid artery disease, varicose veins, and circulation-related disorders."
        }
      },
      {
        "@type": "Question",
        "name": "How long is hospital stay after CTVS procedures?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Hospital stay varies by procedure but typically ranges from 5 to 10 days, including ICU monitoring and recovery care."
        }
      },
      {
        "@type": "Question",
        "name": "What kind of pre-surgery evaluation is done before CTVS?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Patients undergo detailed cardiac tests, imaging, blood investigations, and risk assessment to ensure safe and personalized treatment planning."
        }
      },
      {
        "@type": "Question",
        "name": "Does HDNA Aarogyam Hospital provide post-surgery rehabilitation and follow-up care?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. We offer structured rehabilitation programs, lifestyle counseling, medication management, and regular follow-ups for long-term heart and vascular health."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaCtvs;
